import { api_POST, api_GET, api_PUT } from "./_api";

const notificacao_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Notificacao/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    PendentesDeJustificativa: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Notificacao/PendentesDeJustificativa`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    GetListAnalise: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Notificacao/GetListAnalise`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Notificacao/GetItem/` + id)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    SalvarJustificativa: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Notificacao/SalvarJustificativa/`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    AtualizarJustificativaFiscal: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Notificacao/AtualizarJustificativaFiscal/`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    }
}
export default notificacao_api;